<template>
  <div class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف {{ role.title }} اطمینان دارید؟!</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal" @click="deleteRole">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div>
          <div v-if="getPermission(1030).view | getPermission(1040).view" class="col-md-4">
            <label class="form-control-label required" for="companyTitle">لطفا شرکت مد نظر خود را انتخاب کنید</label>
            <treeselect v-model="companyId" :multiple="false" placeholder="انتخاب کنید" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" />
          </div>
        </div>
        <div>
          <hr class="horizontal dark" />
        </div>
        <div class="table-responsive p-0">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th style="width: 18%;">پیش فرض کاربران جدید</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(r, index) in roles" :key="r.id">
                <td scope="row">{{ index + 1 }}</td>
                <td>{{ r.title }}</td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="r.isPersonnelDefault">
                    <i class="ni ni-check-bold" />
                  </div>
                </td>
                <td>
                  <button v-if="getPermission(1030).insert | getPermission(1090).insert"
                    class="btn btn-sm bg-gradient-success mb-0" @click="goToCopy(r.id)" title="رو‌نویسی">
                    <fa-icon icon="fas fa-copy" />
                  </button>
                  <button v-if="getPermission(1030).update | getPermission(1090).update"
                    class="btn btn-sm bg-gradient-warning mb-0" @click="goToEdit(r.id)" title="ویرایش">
                    <fa-icon icon="fas fa-pencil" />
                  </button>
                  <button v-if="getPermission(1040).update | getPermission(1080).update"
                    class="btn btn-sm bg-gradient-primary mb-0" @click="goToMembers(r.id)" title="کاربران عضو">
                    <fa-icon icon="fas fa-user" />
                  </button>
                  <button v-if="getPermission(1030).delete | getPermission(1090).delete"
                    class="btn btn-sm bg-gradient-danger mb-0" @click="setRole(r)" data-bs-toggle="modal"
                    data-bs-target="#warning" title="حذف">
                    <fa-icon icon="fas fa-trash" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr class="horizontal dark" />
        </div>
        <div>
          <button v-if="getPermission(1030).insert | getPermission(1090).insert" class="btn bg-gradient-success mb-0"
            @click="goToAdd">افزودن نقش جدید</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import RoleService from '@/services/User/Role-service.js';
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  data() {
    return {
      roles: [],
      role: {},
      title: '',
      companies: [],
      companyId: null
    };
  },
  computed: {
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(company) {
      if (company > 0) { this.getRoles(); }
      else { this.roles = []; }
    }
  },
  methods: {
    getCompanies() {
      CompanyService.getCompanyList().then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.companies = result.data;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getRoles() {
      RoleService.getRolesByCompanyId(this.companyId).then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.roles = result.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    setRole(role) {
      this.role = role;

      this.title = this.role.title;
    },
    submit() {
      let newRole = {
        Title: this.title,
        CompanyId: this.company.id
      }
      if (this.role.id) {
        let editedRole = {
          Id: this.role.id,
          CompanyId: this.company.id,
          Title: this.title
        };
        RoleService.updateRole(editedRole).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        RoleService.addRole(newRole).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      setTimeout(() => this.getRoles(), 500);
    },
    deleteRole() {
      let roleId = this.role.id;

      RoleService.deleteRole(roleId).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          let index = this.roles.indexOf(this.role);
          this.roles.splice(index, 1);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goToAdd() {
      if (this.companyId > 0) {
        this.$router.push('/addRole/' + this.companyId);
      }
      else {
        this.$router.push('/addRole/0');
      }
    },
    goToEdit(roleId) {
      this.$router.push('/updateRole/' + roleId);
    },
    goToCopy(roleId) {
      this.$router.push('/copyRole/' + roleId);
    },
    goToMembers(roleId) {
      this.$router.push('/roleUsers/' + roleId);
    },
  },
  created() {
    this.companies.push(this.$store.state.currentUserInfo.companies);

    if (this.$route.params.companyId > 0) {
      this.companyId = this.$route.params.companyId;
    }
    else {
      this.companyId = this.$store.state.currentUserInfo.companyId;
    }
  }
}
</script>